import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/background2.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { style: {"font-size":"6rem","text-align":"center"} }, [
  /*#__PURE__*/_createTextVNode("Towards AI's "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "brand-title",
    style: {}
  }, "AI Tutor")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center mx-5" }, [
  /*#__PURE__*/_createTextVNode(" Hi! I am Towards AI's AI tutor, built to answer anything about LLMs and powered by Deep Lake. I’ll be your course companion for the "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://learn.activeloop.ai/collections" }, "GenAI 360"),
  /*#__PURE__*/_createTextVNode(" certification courses. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_chat_bot = _resolveComponent("chat-bot")!
  const _component_instructions = _resolveComponent("instructions")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_course_section = _resolveComponent("course-section")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_spacer, { style: {"height":"10vh","background-color":"#002233"} }),
    _createVNode(_component_v_row, { style: {"background-color":"#002233","color":"white"} }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "justify-center vertical-align-center pb-3" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "justify-center vertical-align-center" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "mb-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_chat_bot)
      ]),
      _: 1
    }),
    _createVNode(_component_v_spacer, { style: {"height":"5vh"} }),
    _createVNode(_component_v_row, { class: "my-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_instructions)
      ]),
      _: 1
    }),
    _createVNode(_component_v_img, {
      src: _imports_0,
      width: "100%"
    }),
    _createVNode(_component_v_spacer, { style: {"height":"5vh","background-color":"#002233"} }),
    _createVNode(_component_v_row, {
      style: {"background-color":"#002233","color":"white"},
      class: "py-10 d-flex justify-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_course_section)
      ]),
      _: 1
    }),
    _createVNode(_component_v_spacer, { style: {"height":"5vh","background-color":"#002233"} })
  ], 64))
}